export default "__VITE_ASSET__BLzUEY50__"